import { Component, Inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CBox_AdminEquipmentListItem } from '@server/services/cbox/public/api/v1/resources/internal/equipment/types';

export interface ConfirmDialogData {
  header: string;
  message: string;
  actionType: 'open' | 'close' | 'other';
  securityKeyword: string;
  note: boolean;
}

@Component({
  selector: 'app-cbox-admin-locker-action-confirmation-dialog',
  templateUrl: './cbox-admin-locker-action-confirmation-dialog.component.html',
  styleUrls: ['./cbox-admin-locker-action-confirmation-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
  ]
})
export class CboxAdminLockerActionConfirmationDialogComponent implements OnInit {
  visible = true;
  confirmDialogHeader = signal<string>('');
  confirmDialogMessage = signal<string>('');
  actionReason = signal<string>('');
  securityKeywordControl = '';

  constructor(
    public dialogRef: MatDialogRef<CboxAdminLockerActionConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    this.data = data;
  }

  ngOnInit() {
    const data = this.data as ConfirmDialogData;
    this.confirmDialogHeader.set(data.header);
    this.confirmDialogMessage.set(data.message);
  }

  SECURITY_KEYWORD() {
    const data = this.data as ConfirmDialogData;
    return data.securityKeyword;
  }

  shouldShowReason() {
    const data = this.data as ConfirmDialogData;
    return data.note === true;
  }

  updateReason(reason: string) {
    this.actionReason.set(reason);
  }

  cancelAction() {
    this.visible = false;
    this.dialogRef.close({
      confirmed: false,
    });
  }

  confirmActionWithReason() {
    this.visible = false;
    this.dialogRef.close({
      confirmed: true,
      reason: this.actionReason()
    });
  }

  canProceed() {
    return this.securityKeywordControl === this.SECURITY_KEYWORD();
  }
}